import * as React from 'react';

export interface IUseOnBlur {
  validateAddress(value: string): void;

  suggestValue: string;
}

export const useOnBlur = ({ suggestValue, validateAddress }: IUseOnBlur) => {
  return React.useCallback(() => validateAddress(suggestValue), [validateAddress, suggestValue]);
};
